import { Box, styled } from "@mui/material";

const StyledBox = styled(Box)(({ theme }) => ({
  '& .RTRList': {
    
  },
  '& .RTRListItem' : {
    '&::marker' : {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.625rem'
    }
  }
  }));

export const StyledCodeInline = styled('code')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: '2px 4px',
  borderRadius: theme.shape.borderRadius,
  fontSize: '0.875rem',
  fontFamily: 'monospace',
}));

export const StyledCodeBlock = styled('pre')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  overflow: 'auto',
  margin: `${theme.spacing(2)} 0`,
  '& code': {
    fontSize: '0.875rem',
    fontFamily: 'monospace',
  },
}));

export const StyledBlockquote = styled(Box)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.grey[300]}`,
  paddingLeft: theme.spacing(2),
  fontStyle: 'italic',
  color: theme.palette.grey[600],
  margin: `${theme.spacing(2)} 0`,
}));

export const StyledImage = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  height: 'auto',
  borderRadius: theme.shape.borderRadius,
  margin: `${theme.spacing(2)} 0`,
}));

export const StyledRelationship = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,
  margin: `${theme.spacing(2)} 0`,
}));
export default StyledBox